<template>
  <div class="d-flex align-center">
    <v-select
      v-bind="$attrs"
      :model-value="getOptionAnswer(option)"
      @update:model-value="setOptionAnswer(option, $event)"
      :items="chitObservationChoices"
      item-value="value"
      item-title="text"
      hide-details="auto"
      density="compact"
      max-width="91px"
      class="mr-6"
    />
    <div class="flex-grow-1">
      {{ option.text }}
    </div>
    <!-- <div v-if="option.comment_required">(Details in comments)</div> -->
  </div>
</template>

<script setup lang="ts">
import type { IChitOption, IChitOptionAnswerData } from '@/models/chit'

interface Props {
  option: IChitOption
}

defineProps<Props>()
const chitOptionAnswers = defineModel<IChitOptionAnswerData[]>({ default: () => [] })

const chitObservationChoices = [
  { text: 'Yes', value: true },
  { text: 'No', value: false },
  { text: 'N/A', value: null }
]

function getOptionAnswer(option: IChitOption): boolean | null {
  const answer = chitOptionAnswers.value.find((optionAnswer) => {
    const optionQuestion =
      typeof optionAnswer.option == 'number' ? optionAnswer.option : optionAnswer.option!.id
    return optionQuestion === option.id
  })
  if (!answer) {
    return null
  }
  return answer.answer ?? null
}

function setOptionAnswer(option: IChitOption, value: boolean | null) {
  const idx = chitOptionAnswers.value.findIndex((optionAnswer) => {
    const optionQuestion =
      typeof optionAnswer.option == 'number' ? optionAnswer.option : optionAnswer.option!.id
    return optionQuestion === option.id
  })
  if (idx !== -1) {
    // If the condition is boolean, update the answer
    if (value != null) {
      chitOptionAnswers.value[idx].answer = value
    } else {
      // If the condition is null, remove the answer
      chitOptionAnswers.value.splice(idx, 1)
    }
  } else {
    chitOptionAnswers.value.push({
      option: option,
      answer: value
    })
  }
}
</script>
